import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type TypeAppInfoStore = {
  appType: string | null;
  firebaseToken: string | null;
  actions: {
    setAppType: (appType: string | null) => void;
    setFirebaseToken: (firebaseToken: string | null) => void;
  };
};

/** @description 앱과 관련된 정보로 분기 처리를 할 때 사용되는 상태 */
export const useAppInfoStore = create<TypeAppInfoStore>()(
  devtools((set) => ({
    appType: null,
    firebaseToken: null,
    actions: {
      setAppType: (appType) => set({ appType }),
      setFirebaseToken: (firebaseToken) => set({ firebaseToken }),
    },
  }))
);
